// LogoSmall.jsx

import React, { useCallback, useMemo } from 'react';

// Context
import { useNavigation } from 'context/NavigationContext';

// Routing
import { useNavigate } from 'react-router-dom';

// Utilities
import { SectionType } from 'utilities/Enums';

// CSS
import './LogoSmall.css';

// Components
import PlanesMark from '../mark/PlanesMark';

const DEFAULT_LOGO_WIDTH = 120;
const DEFAULT_MARK_SIZE = 26;

/**
 * LogoSmall
 *
 * Renders the Planes mark + Appdeck wordmark used in the app chrome.
 *
 * @param {string|number} [width='120px'] - Approximate rendered width used to scale the logo.
 * @param {string} [homePath='/'] - Path to navigate on click.
 *
 * @returns {ReactNode} LogoSmall.
 */
const LogoSmall = ({ width = '120px', align = 'flex-start', homePath = '/' }) => {

  // ----- CONTEXT ----- //

  const { setCurrentSection } = useNavigation();

  // ----- ROUTING ----- //

  const navigate = useNavigate();

  // ----- MEMOS ----- //

  const scale = useMemo(() => {
    const numeric = parseFloat(String(width));
    if (!Number.isFinite(numeric) || numeric <= 0) {
      return 1;
    }

    return numeric / DEFAULT_LOGO_WIDTH;
  }, [width]);

  const markSize = DEFAULT_MARK_SIZE * scale;

  // ----- HANDLERS ----- //

  const handleClick = useCallback(() => {
    setCurrentSection(SectionType.HOME);
    navigate(homePath || '/');
  }, [homePath, navigate, setCurrentSection]);

  // ----- RENDER ----- //

  // TODO: Remove this once the logo is updated
  //return null;

  return (
    <div
      className="logo-small-container"
      style={{
        '--logo-small-scale': scale,
      }}
      onClick={handleClick}
    >
      {/* 
      <PlanesMark
        className="logo-small-mark"
        size={markSize}
      />
      */}
      {/* HomeStudio | HomeRun*/}
      <span className="logo-small-wordmark">
       playbook
        <span className="logo-small-wordmark-subtitle" style={{ textAlign: align }}>by Appdeck</span>

        {/*
        <span className="logo-small-tm" aria-hidden="true">™</span>
        */}
      </span>



    </div>
  );
};

// Dev Tools
LogoSmall.displayName = 'LogoSmall';

export default LogoSmall;
